
import { ITab } from '@/types/detailPages'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DecoBar extends Vue {
  @Prop() tabs!: ITab[]
  @Prop() show_tabs!: boolean
  @Prop() mainColor!: string

  get title (): string {
    const activeTab = this.tabs.find(tab => tab.is_active)
    return activeTab ? activeTab.navbar_settings.title : ''
  }

  get logoUrl (): string {
    const activeTab = this.tabs.find(tab => tab.is_active)
    return activeTab ? activeTab.navbar_settings.logo_url : ''
  }

  setActiveTab (key: string): void {
    this.$emit('tab-clicked', key)
  }

  getTabByKey (key: string): ITab {
    return this.tabs.find(tab => tab.key === key) as ITab
  }

  getTabBackgroundColor (tabKey) {
    const tab = this.getTabByKey(tabKey)
    if (tab.is_active) {
      return {
        color: this.mainColor + " !important"
      }
    }
  }
}
